import {useCallback, useContext} from 'react';

import moment from 'moment';
import {
    DOWNLOAD_FAILED_MESSAGE,
    DOWNLOAD_REQUEST_MESSAGE,
    DOWNLOAD_SUCCESS_MESSAGE,
    STACKOVERFLOW_MESSAGE,
} from 'src/constants';
import {useBackgroundTaskManager} from 'src/contexts/background-task-context';
import {mapDateFormat} from 'src/utils/mapDateFormat';

import {LocaleContext} from '@pb/kit-context-locale';

import {downloadCSV} from './utils/csv-download';

type Props = {
    fileName: string,
    content: (string | number | undefined)[][],
};

export const useDownloadReport = ({fileName, content}: Props) => {
    const createBackgroundTask = useBackgroundTaskManager();
    const {locale} = useContext(LocaleContext);

    return useCallback(() => {
        const downloadTask = createBackgroundTask(
            'file-download',
            DOWNLOAD_REQUEST_MESSAGE,
            {
                maxStack: 1,
                stackOverflowMessage: STACKOVERFLOW_MESSAGE,
            },
        );

        if (!downloadTask) {
            return;
        }

        try {
            let csvContent = '';
            content.filter(Boolean).forEach((infoArray, index) => {
                const dataString = infoArray.join();
                csvContent += index < content.length ? dataString + '\n' : dataString;
            });

            downloadCSV(csvContent, `${fileName}-${moment().format(
                mapDateFormat(locale.dateFormat, 'FILE_NAME', 'DATE_TIME'),
            )}.csv`);
            downloadTask.completeSuccess(DOWNLOAD_SUCCESS_MESSAGE);
        } catch (e) {
            if (e) {
                downloadTask.completeFailure(DOWNLOAD_FAILED_MESSAGE);
            }
        }
    }, [fileName, content, createBackgroundTask, locale.dateFormat]);
};
